import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styles from "./RefinanceForm.module.css";

const TWILIO_API_URL =
  "https://fox00890i2.execute-api.ap-southeast-2.amazonaws.com/prod/twilio";
const API_KEY = "B6tlsUua0xaRI4VFeb9175K3ee9A5WLuahjbyZwN";

// ✅ Replace with your deployed getLeadByMobile endpoint
const LOOKUP_URL =
  "https://<your-api-id>.execute-api.ap-southeast-2.amazonaws.com/default/getLeadByMobile";

const TEST_MODE = true;

function RefinanceStart({ formData, setFormData, nextStep }) {
  const [otpSent, setOtpSent] = useState(false);
  const [otpCode, setOtpCode] = useState("");
  const [otpVerified, setOtpVerified] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      applicant1: { ...(formData.applicant1 || {}), phone: e.target.value },
    });
  };

  const fetchExisting = async (mobile04) => {
    console.log("🔍 Fetching Mercury data for", mobile04);
    try {
      const resp = await fetch(LOOKUP_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ mobile: mobile04 }),
      });
      const data = await resp.json();
      console.log("📦 Mercury response:", data);

      if (data.success && data.found) {
        toast.info("Existing details found — prefilled.");
        setFormData((prev) => ({
          ...prev,
          applicant1: {
            ...(prev.applicant1 || {}),
            firstName: data.firstName || "",
            lastName: data.lastName || "",
            email: data.email || "",
            phone: data.mobile || mobile04,
          },
          mercuryContactId: data.contactId || "",
          mercuryOpportunityId: data.opportunityId || "",
        }));
      } else {
        toast.info("No existing record found — new lead.");
        setFormData((prev) => ({
          ...prev,
          applicant1: { ...(prev.applicant1 || {}), phone: mobile04 },
        }));
      }
    } catch (err) {
      console.error("❌ Mercury lookup failed:", err);
      toast.error("Error checking Mercury for existing contact.");
    }
  };

  const handleTestNext = async () => {
    const raw = formData.applicant1?.phone || "";
    if (!raw) {
      toast.error("Enter a mobile number before continuing");
      return;
    }
    const mobile04 = normaliseAU(raw);
    setLoading(true);
    await fetchExisting(mobile04);
    setOtpVerified(true);
    setLoading(false);
    toast.success("✅ Mobile verified (Test Mode)");
    nextStep();
  };

  return (
    <div className={styles.container}>
      <div className={styles.stepHeaderCompact}>
        <div className={styles.stepBarTrack}>
          <div className={styles.stepBarFill} style={{ width: `14.3%` }} />
        </div>
        <div className={styles.stepMeta}>
          <span className={styles.stepCenter}>
            Step 1 of 7: Mobile Verification
          </span>
        </div>
      </div>

      <div className={styles.formRow}>
        <input
          type="tel"
          placeholder="04xxxxxxxx"
          value={formData.applicant1?.phone || ""}
          onChange={handleChange}
          maxLength="10"
          className={styles.fullWidthInput}
        />

        {/* ✅ Test Mode skip */}
        {TEST_MODE && (
          <button
            className={`${styles.nextBtn} ${styles.fullWidthBtn}`}
            onClick={handleTestNext}
            disabled={loading}
          >
            {loading ? "Checking..." : "Next →"}
          </button>
        )}
      </div>

      {TEST_MODE && (
        <p style={{ textAlign: "center", color: "orange", marginTop: "10px" }}>
          ⚙️ Test Mode Active – OTP Skipped
        </p>
      )}
      <ToastContainer position="top-center" autoClose={3000} hideProgressBar />
    </div>
  );
}

export default RefinanceStart;

function normaliseAU(n = "") {
  let x = n.replace(/\D/g, "");
  if (x.startsWith("61")) x = "0" + x.slice(2);
  if (!x.startsWith("0")) x = "0" + x;
  return x.slice(0, 10);
}
